<template>
  <div class="wrapper">
    <nav class="navbar">
      <a href="/"><div class="logo">PrintStation.fr</div></a>
      <ul class="menu" :class="{ 'menu--active': isMenuOpen }">
        <li><a href="about">À propos de nous</a></li>
        <li><a href="contact">Contactez-nous</a></li>
      </ul>
      <div class="burger" @click="toggleMenu">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "MenuApp",
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>

<style scoped>
.wrapper {
  background-color: #000;
}
.navbar {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #000;
  position: relative;
}

.logo {
  font-weight: bold;
  font-size: 18px;
  color: #fff;
}

.menu {
  list-style: none;
  display: flex;
  gap: 20px;
  padding: 0;
  margin: 0;
  max-width: 70%; /* Limite la largeur du menu à 70% */
  justify-content: space-around; /* Centrer le contenu dans le menu */
}

.menu li a {
  text-decoration: none;
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  transition: color 0.3s ease;
}

.menu li a:hover {
  color: #aaa;
}

.burger {
  display: none;
  cursor: pointer;
  flex-direction: column;
  gap: 5px;
}

.burger .bar {
  width: 30px;
  height: 3px;
  background-color: #fff;
  border-radius: 5px;
}

@media (max-width: 768px) {
  .navbar {
    width: auto;
  }
  .menu {
    display: none;
    flex-direction: column;
    gap: 10px;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #000;
    border-top: 1px solid #e0e0e0;
    padding: 10px 0;
    align-items: center;
    max-width: 100%; /* Le menu prend toute la largeur sur mobile */
  }

  .menu--active {
    display: flex;
  }

  .burger {
    display: flex;
  }
}
</style>